import {
  Card,
  Table,
  Stack,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  Button,
  TablePagination,
  LinearProgress,
  Grid,
  TextField,
} from '@mui/material';

import { useEffect } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { get, omitBy, isEmpty } from 'lodash';
import { useForm, Controller } from 'react-hook-form';
import FileDownload from 'js-file-download';
import { format } from 'date-fns';
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import { UserListHead } from '../sections/@dashboard/user';

// store
import { api as stockApi, hooks as stockHooks } from '../store/domains/stock';

const TABLE_HEAD = [
  { id: 'iccid', label: 'ICCID', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'msisdn', label: 'Msisdn', alignRight: false },
  { id: 'hubId', label: 'Hub', alignRight: false },
  { id: 'partnerIdCurrent', label: 'Partner ID (current)', alignRight: false },
  { id: 'partnerIdPrevious', label: 'Partner ID (previous)', alignRight: false },
  { id: 'modelName', label: 'Model', alignRight: false },
  { id: 'assignDate', label: 'Assign Date', alignRight: false },
  { id: 'assignTime', label: 'Assign Time', alignRight: false },
  { id: 'user', label: 'User', alignRight: false },
];

export default function IccId() {
  const { handleChangeRowsPerPage, handleClick, rowsPerPage, page, handleChangePage, selected, resetSelectedList } =
    stockHooks.useStock();

  const { control, handleSubmit, getValues, reset } = useForm({
    defaultValues: {
      minIccid: '',
      maxIccid: '',
      previousPartnerId: '',
      currentPartnerId: '',
      iccidType: '',
      eventType: '',
      responsibleUser: '',
    },
  });

  const [trigger, { data, isLoading, isFetching }] = stockApi.useGetIccidLogs();
  const [downloadLogs, { isLoading: downloadLoding, isFetching: downloadFetching }] =
    stockApi.useGetIccidLogsDownload();
  useEffect(() => {
    const extraParams = omitBy({ ...getValues() }, (v) => v.toString().length < 1);
    trigger({
      page,
      size: rowsPerPage,
      ...extraParams,
    });
  }, [page, rowsPerPage, trigger, getValues]);
  const handleSearch = (data) => {
    const extraParams = omitBy({ ...data, iccids: selected.join(',') }, (v) => v.toString().length < 1);
    trigger({ page, size: rowsPerPage, ...extraParams });
  };
  const handleDownload = async (data) => {
    const extraParams = omitBy({ ...data, iccids: selected.join(',') }, (v) => v.toString().length < 1);
    try {
      const res = await downloadLogs({
        page,
        size: rowsPerPage,
        ...extraParams,
      }).unwrap();

      const date = format(new Date(), 'yyyy-MM-dd-HH-mm-ss');
      FileDownload(res, `IccidHistoryReport-${date}.xlsx`);
    } catch (error) {
      console.log(error);
    }
  };
  const handleClear = () => {
    reset();
    resetSelectedList();
  };

  
  return (
    <Page title="User">
      <Container>
        <Stack direction="row" alignItems="center" mb={5}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid spacing={2} container>
              <Grid item xs={3}>
                {' '}
                <Controller
                  name="minIccid"
                  control={control}
                  render={({ field }) => (
                    <TextField disabled={!isEmpty(selected)} fullWidth label="Min Iccid" {...field} />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                {' '}
                <Controller
                  name="maxIccid"
                  control={control}
                  render={({ field }) => (
                    <TextField disabled={!isEmpty(selected)} fullWidth label="Max Iccid" {...field} />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="iccidType"
                  control={control}
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <InputLabel>Iccid type:</InputLabel>
                      <Select label="Iccid type" {...field}>
                        <MenuItem value={''}>None</MenuItem>
                        <MenuItem value={'FREE_COMPOUND'}>FREE_COMPOUND</MenuItem>
                        <MenuItem value={'STARTER_PACK'}>STARTER_PACK</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="eventType"
                  control={control}
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <InputLabel>Event type:</InputLabel>
                      <Select label="Event type" {...field}>
                        <MenuItem value={''}>None</MenuItem>
                        <MenuItem value={'ASSIGNED'}>ASSIGNED</MenuItem>
                        <MenuItem value={'UNASSIGNED'}>UNASSIGNED</MenuItem>
                        <MenuItem value={'TRANSFERRED'}>TRANSFERRED</MenuItem>
                        <MenuItem value={'SOLD'}>SOLD</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />
              </Grid>

              <Grid item xs={3}>
                <Controller
                  name="previousPartnerId"
                  control={control}
                  render={({ field }) => <TextField fullWidth label="Previous partner ID" {...field} />}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="currentPartnerId"
                  control={control}
                  render={({ field }) => <TextField fullWidth label="Current partner ID" {...field} />}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="responsibleUser"
                  control={control}
                  render={({ field }) => <TextField fullWidth label="Responsible user" {...field} />}
                />
              </Grid>
              <Grid item xs={3}>
                <Button
                  sx={{
                    height: '100%',
                  }}
                  fullWidth
                  variant="contained"
                  onClick={handleSubmit(handleSearch)}
                >
                  Search
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  sx={{
                    height: '100%',
                  }}
                  fullWidth
                  variant="contained"
                  onClick={handleClear}
                >
                  Clear filters
                </Button>
              </Grid>

              <Grid item xs={6}>
                <Button
                  disabled={downloadLoding || downloadFetching}
                  sx={{
                    height: '100%',
                  }}
                  fullWidth
                  variant="contained"
                  onClick={handleSubmit(handleDownload)}
                >
                  Download report
                </Button>
              </Grid>
            </Grid>
          </LocalizationProvider>
        </Stack>
        <Card>
          {(isLoading || isFetching || downloadLoding || downloadFetching) && <LinearProgress />}
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead headLabel={TABLE_HEAD} rowCount={data?.data?.length} numSelected={selected.length} />
                <TableBody>
                  {data?.data?.map((row) => {
                    const {
                      iccid,
                      iccidStatus,
                      msisdn,
                      hub,
                      currentPartnerId,
                      previousPartnerId,
                      modelName,
                      eventDate,
                      eventTime,
                      responsibleUser,
                    } = row;
                    const isItemSelected = selected.indexOf(iccid) !== -1;

                    return (
                      <TableRow hover key={iccid} tabIndex={-1} selected={isItemSelected} aria-checked={isItemSelected}>
                        <TableCell padding="checkbox">
                          <Checkbox
                            disabled={false}
                            checked={isItemSelected}
                            onChange={(event) => {
                              handleClick(event, iccid);
                            }}
                          />
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {iccid}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">{iccidStatus}</TableCell>
                        <TableCell align="center">{msisdn || '-'}</TableCell>
                        <TableCell align="center">{hub}</TableCell>
                        <TableCell align="center">{currentPartnerId}</TableCell>
                        <TableCell align="center">{previousPartnerId || '-'}</TableCell>
                        <TableCell align="left">{modelName}</TableCell>
                        <TableCell align="center">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography noWrap>{eventDate}</Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="center">{eventTime}</TableCell>
                        <TableCell align="center">{responsibleUser}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={get(data, 'metadata.pagination.total', 0)}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
